// alert-session.service.ts
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { SsoService } from 'src/app/core/services/sso.service';
import { AlertSseService } from './alert-sse.service';
import { CommonService } from '../../shared/service/common.service';
import { ALERT_STATUS } from '../../shared/api.constant';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AlertSessionService {
  private isRunning = false;
  private statusSub?: Subscription;
  private statusVehicleTypeCode?: string;

  constructor(
    private readonly ssoService: SsoService,
    private readonly alertSseService: AlertSseService,
    private readonly commonService: CommonService
  ) {}

  init() {
    const vehicleTypeCode = this.commonService.getVehicleTypeCode();
    const token = this.commonService.getAccessToken();

    if (!vehicleTypeCode || !token) {
      return;
    }

    // Login fires init() from both the auth and vehicle subscriptions in
    // app.component; a status call already in flight for this vehicle type
    // covers the second one.
    if (this.statusSub && !this.statusSub.closed) {
      if (this.statusVehicleTypeCode === vehicleTypeCode) {
        return;
      }
      this.statusSub.unsubscribe();
    }

    if (this.isRunning) {
      this.stop();
    }

    this.statusVehicleTypeCode = vehicleTypeCode;
    this.statusSub = this.ssoService
      .getSharedURL(ALERT_STATUS, { vehicleTypeCode })
      .subscribe({
        next: (res: any) => {
          if (!res?.status) {
            return;
          }

          const { noNotificationForRole, noNotificationPrefSelected } =
            res.data.response;

          this.alertSseService.setNotificationStatus({
            hasPermission: noNotificationForRole,
            isSubscribed: noNotificationPrefSelected,
          });

          if (noNotificationForRole && noNotificationPrefSelected) {
            const sseUrl = `${environment.apiBaseUrl}sse-service/v1/new-alert-status?vehicleTypeCode=${vehicleTypeCode}`;

            const headers = {
              authorization: token,
            };

            this.alertSseService.start(sseUrl, headers);
            this.isRunning = true;
          } else {
            this.stop();
          }
        },
        error: (err) => {
          this.stop();
        },
      });
  }

  stop() {
    this.statusSub?.unsubscribe();
    this.alertSseService.resetState();
    this.isRunning = false;
  }

  reset() {
    this.stop();
    this.init();
  }
}
